export default __webpack_public_path__ + "static/Sebastian_websize-231addd6cdb134650f3754d2d01d047c.jpg";